import { useState, useEffect, useRef } from "react";
import { Search, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

interface SearchResult {
  title: string;
  href: string;
  category: string;
}

const getSearchablePages = (lang: string): SearchResult[] => [
{ title: lang === "sl" ? "Domov" : "Home", href: "/", category: lang === "sl" ? "Strani" : "Pages" },
{ title: lang === "sl" ? "O nas" : "About us", href: "/about-us", category: lang === "sl" ? "Strani" : "Pages" },
{ title: lang === "sl" ? "Novice & znanje" : "Knowledge Hub", href: "/knowledge-hub", category: lang === "sl" ? "Strani" : "Pages" },
{ title: "FAQ", href: "/faq", category: lang === "sl" ? "Strani" : "Pages" },
{ title: lang === "sl" ? "Storitve" : "Services", href: "/services", category: lang === "sl" ? "Strani" : "Pages" },
{ title: lang === "sl" ? "Pričevanja" : "Testimonials", href: "/testimonials", category: lang === "sl" ? "Reference" : "References" },
{ title: lang === "sl" ? "Uporabniki" : "Users & Clients", href: "/users-clients", category: lang === "sl" ? "Reference" : "References" },
{ title: lang === "sl" ? "Partnerji" : "Partners", href: "/partners", category: lang === "sl" ? "Reference" : "References" },
// Products
{ title: lang === "sl" ? "Produkti" : "Products", href: "/products", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Točkovno varjenje" : "Spot Welding", href: "/products/spot-welding", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RS-81 / RP-81 MFDC", href: "/products/spot-welding/rs-81", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RB-81", href: "/products/spot-welding/rb-81", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RT-94", href: "/products/spot-welding/rt-94", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RP-96-X", href: "/products/spot-welding/rp-96-x", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RP-96-C", href: "/products/spot-welding/rp-96-c", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "Car Point", href: "/products/spot-welding/car-point", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "Europei", href: "/products/spot-welding/europei", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "MFDC Welding Unit", href: "/products/spot-welding/mfdc-welding-unit", category: lang === "sl" ? "Produkti" : "Products" },
{ title: "RP-84/3,5-ECO", href: "/products/spot-welding/fast-spotter", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Bradavičasto varjenje RT-94" : "Projection Welding RT-94", href: "/products/projection-welding", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Sočelno varjenje RP-97" : "Butt Welding RP-97", href: "/products/butt-welding", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Mikro varjenje" : "Micro Welding", href: "/products/micro-welding", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Varilne glave" : "Welding Heads", href: "/products/welding-heads", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Varilne klešče" : "Welding Pincers", href: "/products/welding-pincers", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Obdelava baterij" : "Battery Processing", href: "/products/battery-processing", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Orodje za upogibanje IC" : "IC Bending Tool", href: "/products/ic-bending-tool", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Delovna postaja" : "Workstation", href: "/products/workstation", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Avtoličarstvo" : "Car Spotters", href: "/products/car-spotters", category: lang === "sl" ? "Produkti" : "Products" },
// Solutions
{ title: lang === "sl" ? "Specialni stroji" : "Solutions", href: "/solutions", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Gastronomija & medicina" : "Gastronomy & Medicine", href: "/solutions/gastronomy-medicine", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Točkovno varjenje korit" : "Spot Welding Sinks", href: "/solutions/spot-welding-sinks", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Kolutno varjenje" : "Seam Welding Pillow Plates", href: "/solutions/seam-welding-pillow-plates", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Robotske varilne pištole" : "Robotic Spot Welding Guns", href: "/solutions/robotic-spot-welding-guns", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Stiskalna orodja" : "Compacting Tools", href: "/solutions/compacting-tools", category: lang === "sl" ? "Rešitve" : "Solutions" },
{ title: lang === "sl" ? "Varjenje ključavnic" : "Lock Welding", href: "/solutions/lock-welding", category: lang === "sl" ? "Rešitve" : "Solutions" },
// Spare parts & consumables
{ title: lang === "sl" ? "Rezervni deli" : "Spare Parts", href: "/spare-parts", category: lang === "sl" ? "Deli" : "Parts" },
{ title: "Bosch Rexroth", href: "/spare-parts/bosch-rexroth", category: lang === "sl" ? "Deli" : "Parts" },
{ title: "Harms & Wende", href: "/spare-parts/harms-wende", category: lang === "sl" ? "Deli" : "Parts" },
{ title: lang === "sl" ? "Potrošni material" : "Consumables", href: "/consumables", category: lang === "sl" ? "Deli" : "Parts" },
{ title: lang === "sl" ? "Posnemovalci kapic" : "Tip Dressers", href: "/accessories/tip-dressers", category: lang === "sl" ? "Deli" : "Parts" },
// Pedestal / projection / seam welders
{ title: lang === "sl" ? "Stacionarni varilni stroji" : "Industrial Pedestal Welders", href: "/products/industrial-pedestal-welders", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Industrijski stroji za bradavičasto varjenje" : "Industrial Projection Welders", href: "/products/industrial-projection-welders", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Industrijski stroji za kolutno varjenje" : "Industrial Seam Welders", href: "/products/industrial-seam-welders", category: lang === "sl" ? "Produkti" : "Products" },
{ title: lang === "sl" ? "Večtočkovni varilni stroj" : "Multi Spot Welding Machine", href: "/products/multi-spot-welding-machine", category: lang === "sl" ? "Produkti" : "Products" }];


// Fuzzy match: allows skipped/wrong characters with scoring
function fuzzyMatch(text: string, pattern: string): number {
  text = text.toLowerCase();
  pattern = pattern.toLowerCase();
  
  // Exact substring match = highest score
  if (text.includes(pattern)) return 100;
  
  // Levenshtein-based fuzzy for short queries
  if (pattern.length >= 2) {
    // Check if any word in text starts with the pattern
    const words = text.split(/\s+/);
    for (const word of words) {
      if (word.startsWith(pattern)) return 90;
    }
    
    // Simple Levenshtein distance for fuzzy matching
    const distance = levenshtein(text, pattern);
    const maxLen = Math.max(text.length, pattern.length);
    const similarity = 1 - distance / maxLen;
    if (similarity >= 0.4) return Math.round(similarity * 80);
    
    // Subsequence match: all chars of pattern appear in order
    let ti = 0;
    let matched = 0;
    for (let pi = 0; pi < pattern.length; pi++) {
      while (ti < text.length) {
        if (text[ti] === pattern[pi]) { matched++; ti++; break; }
        ti++;
      }
    }
    if (matched === pattern.length) return 50;
  }
  
  return 0;
}

function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1]
        : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
}

const SiteSearch = () => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const { lang } = useLanguage();

  const pages = getSearchablePages(lang);

  const results = query.length >= 2
    ? pages
        .map((p) => ({ ...p, score: fuzzyMatch(p.title, query) }))
        .filter((p) => p.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, 10)
    : [];

  useEffect(() => {
    if (open) {
      setTimeout(() => inputRef.current?.focus(), 100);
    } else {
      setQuery("");
    }
  }, [open]);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setOpen(true);
      }
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    navigate(href);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="text-foreground/70 hover:text-foreground lg:text-primary-foreground/90 lg:hover:text-primary-foreground transition-colors p-1"
        aria-label="Search">
        
        <Search className="w-[18px] h-[18px]" strokeWidth={2} />
      </button>

      {open &&
      <div className="fixed inset-0 z-[100] flex items-start justify-center pt-[15vh]" onClick={() => setOpen(false)}>
          <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
          <div
          className="relative w-full max-w-lg mx-4 bg-background rounded-xl shadow-2xl border border-border/30 overflow-hidden"
          onClick={(e) => e.stopPropagation()}>
          
            <div className="flex items-center gap-3 px-4 py-3 border-b border-border/20">
              <Search className="w-5 h-5 text-muted-foreground shrink-0" />
              <input
              ref={inputRef}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={lang === "sl" ? "Iščite po strani..." : "Search the site..."}
              className="flex-1 bg-transparent text-base outline-none placeholder:text-muted-foreground/60" />
            
              <button onClick={() => setOpen(false)} className="p-1 text-muted-foreground hover:text-foreground">
                <X className="w-4 h-4" />
              </button>
            </div>

            {query.length >= 2 &&
          <div className="max-h-[50vh] overflow-y-auto p-2">
                {results.length === 0 ?
            <p className="text-sm text-muted-foreground text-center py-8">
                    {lang === "sl" ? "Ni rezultatov" : "No results found"}
                  </p> :

            results.map((r) =>
            <button
              key={r.href}
              onClick={() => go(r.href)}
              className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-left hover:bg-accent transition-colors">
              
                      <span className="text-sm font-medium">{r.title}</span>
                      <span className="text-xs text-muted-foreground">{r.category}</span>
                    </button>
            )
            }
              </div>
          }

            <div className="px-4 py-2 border-t border-border/20 flex items-center justify-end">
              
            </div>
          </div>
        </div>
      }
    </>);

};

export default SiteSearch;